if (!customElements.get('cart-recommendations')) {
  class CartRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) return;
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendationsHMTL = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]').innerHTML;
          if (!recommendationsHMTL) return;
          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
          }
          recommendations.innerHTML = recommendationsHMTL;
          this.initSlider();

          // initiate quick cart after fetch
          // to activate trigger button events
          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            }
          }, 2500);

        });
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
      });
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);
}
